import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-custom-dropdown',
    templateUrl: './custom-dropdown.component.html',
    styleUrls: ['./custom-dropdown.component.css'],
    standalone: false
})

export class CustomDropdownComponent {
  @Input() options: any[] = [];
  @Input() optionLabel: string = 'label';
  @Input() optionValue: string = 'value';
  @Input() placeholder: string = 'Please choose...';
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();
  @Output() changed = new EventEmitter<void>();

  onChange(value: any) {
    this.valueChange.emit(value);
    this.changed.emit();
  }
}
